import type { FeatureStyleNode } from '../features/feature-style.model';

/** Default style for label primitives: tertiary (no background) */
export const LABEL_DEFAULTS: FeatureStyleNode = {
  label: { variant: 'tertiary' },
};

/** Default style for point primitives */
export const POINT_DEFAULTS: FeatureStyleNode = {
  point: { color: 'sky', size: 4 },
};

/** Default style for line primitives: neutral line */
export const LINE_DEFAULTS: FeatureStyleNode = {
  line: { color: 'neutral', strokeWidth: 2 },
};

/** Default style for polygon primitives */
export const POLYGON_DEFAULTS: FeatureStyleNode = {
  polygon: { fillColor: 'sky', fillOpacity: 0.15 },
};
